module.exports = __webpack_public_path__ + "cd081f02d3927464b98245c8880cb14b.png";